import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import QuoteModal from "../../Components/QuoteModal";

const BuildLegacySection = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#FCF9F8",
        py: "160px", // 160px top and bottom
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1280px",
          height: { md: "188px" },
          px: "48px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "48px", // gap between title and actions
          boxSizing: "border-box",
        }}
      >
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h2"
            sx={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: 800,
              fontSize: { xs: "32px", md: "64px" },
              lineHeight: { xs: "1.2", md: "1" },
              color: "#1C1B1B",
              textAlign: "center",
              letterSpacing: "-1.5px",
            }}
          >
            Ready to Build Your Legacy?
          </Typography>
        </motion.div>

        {/* Actions Container */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1184px",
            height: { md: "68px" },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: "24px", // gap: 24px as per requirement
          }}
        >
          {/* Enquire Now Button */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Button
              variant="contained"
              onClick={handleOpen}
              sx={{
                width: "205px",
                height: "68px",
                p: "20px 48px",
                borderRadius: "6px",
                background: "linear-gradient(90deg, #993414 0%, #FF5722 100%)",
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                fontSize: "16px",
                color: "#FFFFFF",
                boxShadow: "0px 10px 30px rgba(153, 52, 20, 0.2)",
                "&:hover": {
                  background:
                    "linear-gradient(90deg, #FF5722 0%, #993414 100%)",
                  boxShadow: "0px 15px 40px rgba(153, 52, 20, 0.3)",
                },
              }}
            >
              Enquire Now
            </Button>
          </motion.div>

          {/* Explore Our Projects Link/Button */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <Typography
              onClick={() => navigate("/projects")}
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                fontSize: "16px",
                color: "#1C1B1B",
                cursor: "pointer",
                textAlign: "center",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#FF5722",
                },
              }}
            >
              Explore Our Projects
            </Typography>
          </motion.div>
        </Box>
      </Box>

      {/* Quote Modal */}
      <QuoteModal open={openModal} onClose={handleClose} />
    </Box>
  );
};

export default BuildLegacySection;
